"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNewsroomContext = void 0;
const react_1 = require("react");
const context_1 = require("../context");
function useNewsroomContext() {
    // TS Compiler is having a hard time figuring this type implicitly, so we have to set it explicitly
    // See https://github.com/microsoft/TypeScript/issues/5711#issuecomment-340283439
    const newsroomContext = (0, react_1.useContext)(context_1.NewsroomContext);
    if (!newsroomContext) {
        throw new Error('No `NewsroomContextProvider` found when calling `useNewsroomContext`');
    }
    return newsroomContext;
}
exports.useNewsroomContext = useNewsroomContext;
//# sourceMappingURL=useNewsroomContext.js.map